import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./notification.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineCloseCircle } from "react-icons/ai";
import notificationIcon from "assets/icons/notification.svg";
import useOutsideAlerter from "hooks/useOutsideAlerter";
import { getAllNotification, markAsRead } from "redux/action/notification";

const NotificationBar = () => {
  const [notificationData, setNotificationData] = useState([]);
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const { isOpen, notifications, isLoading } = useSelector((state) => state.notification);

  const closeNotification = () => {
    dispatch({
      type: "TOGGLE_NOTIFICATION",
      payload: {
        isOpen: false
      }
    });
  };

  useEffect(() => {
    isOpen && setNotificationData(notifications);
  }, [isLoading, isOpen])

  useOutsideAlerter(wrapperRef, closeNotification);

  const handleMarkAsRead = async (payload) => {
    try {
      await markAsRead(dispatch, payload);
      await getAllNotification(dispatch);
    } catch (error) {
      console.log("error", error)
    }
  }

  const [readMessages, unReadMessages] = useMemo(() => {
    let reads = [], unReads = [];
    if (notifications?.length) {
      notifications.map(a => {
        if (a.isRead) reads.push(a);
        else unReads.push(a);
      });
    }
    return [reads, unReads];
  }, [isLoading, notifications])

  return (
    <div className={styles.sideBar} ref={wrapperRef}>
      <div className={styles.heading}>
        <h4 className="m-0">Notifications</h4>
        <div onClick={closeNotification}><AiOutlineCloseCircle size={24} style={{ color: "red", cursor: "pointer" }} /></div>
      </div>
      {notificationData?.length > 0 ? (
        <div className={styles.content_box}>
          {unReadMessages.filter((a) => Boolean(!a?.isRead)).map((data, index) => (
            <div className="bg-white border-bottom" key={index} >
              <div className="d-flex justify-content-between p-3 rounded gap-1">
                <div className={styles.font_bar}>
                  <div className={styles.title}><img src={notificationIcon} className={styles.iconImg} /><p>{data.title}</p></div>
                  <div className={styles.order_text} dangerouslySetInnerHTML={{ __html: data?.description }}>
                    {/* {data.description} */}
                  </div>
                  <div className={styles.isRead} onClick={() => handleMarkAsRead({ notificationId: data?._id, isRead: true })}>Mark as read</div>
                </div>
              </div>
            </div>
          ))}
          {readMessages.filter((a) => Boolean(a?.isRead)).map((data, index) => (
            <div className="border-bottom" key={index} style={{ background: "#eee" }} >
              <div className="d-flex justify-content-between p-3 rounded gap-1">
                <div className={styles.font_bar}>
                  <div className={styles.title}><img src={notificationIcon} className={styles.iconImg} /><p>{data.title}</p></div>
                  <div className={styles.order_text} dangerouslySetInnerHTML={{ __html: data?.description }}>
                    {/* {data.description} */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className={styles.noData}>No Notifications</p>
      )
      }
    </div >
  );
};

export default NotificationBar;
